import { detectInstallPlatform, readPwaStandalone } from '../../auth/utils/pwa-install';

export function getPushActivateErrorMessage(
  userAgent = typeof navigator === 'undefined' ? '' : navigator.userAgent,
  maxTouchPoints = typeof navigator === 'undefined' ? 0 : navigator.maxTouchPoints,
  standalone = typeof window === 'undefined' ? false : readPwaStandalone(),
): string {
  if (detectInstallPlatform(userAgent, maxTouchPoints) !== 'ios') {
    return 'Tente recarregar a página e ativar de novo.';
  }
  if (!standalone) {
    return 'No iPhone, instale o app em Adicionar à Tela de Início e abra por lá. É necessário iOS 16.4 ou superior.';
  }
  return 'Feche o app e abra de novo pelo ícone na tela inicial, depois ative outra vez.';
}
